/* eslint-disable @nx/enforce-module-boundaries */
import { useDisclosure } from '@mybridge/ui/hooks';
import { useRouter } from 'next/router';
import { forwardRef, useEffect } from 'react';
import { DashboardReelModal } from '../reel-modal';

export const GlobalReelContainer = forwardRef(({ ...props }, ref) => {
  const { query, pathname, push } = useRouter();
  const reel = query?.reel;
  const page = query?.page;
  const reelModalDisc = useDisclosure();
  useEffect(() => {
    if (reel?.length) {
      reelModalDisc.onOpen();
    } else {
      // reelModalDisc.onClose();
      reelModalDisc.onClose();
    }
  }, [reel]);

  const handleClose = () => {
    reelModalDisc.onClose();
    const { reel: _r, page: _p, ...restQuery } = query || {};
    push({ pathname, query: restQuery }, undefined, { shallow: true });
  };

  return (
    <>
      {/* {reel?.length > 0 ? ( */}
      {reel?.length > 0 && reelModalDisc?.isOpen ? (
        <DashboardReelModal
          {...reelModalDisc}
          onClose={handleClose}
          reelId={reel}
          page={page}
        />

      ) : (
        ''
      )}
    </>
  );
});
